module.exports = __webpack_public_path__ + "img/cover.b8c9567b.jpg";